import { FC } from 'react';
import { Spin } from 'antd';

type Props = {
  isFullPage?: Boolean,
}


const Loader: FC<Props> = ({ isFullPage = false }) => {
  return (
    <div className={`loader-custom ${isFullPage ? 'loader-custom--fullpage':''}`}>
      <Spin />
    </div>
  );
};

export default Loader;
